import React from 'react';

import {MenuList, MenuListItem as Item} from '~/components/common/MenuList';
import LabeledInput from '~/components/common/LabeledInput';
import DropDown from '~/components/common/DropDown';
import cs from 'classnames';
import css from './index.css';
import * as equipment from '~/misc/equipment';

const values = {"AL": 'All', ...equipment.idToHuman, };

const handle = (props, value) => () => props.onChange(value);

const statusSelect = (props) => (
  <DropDown
    id={props.dropDownId}
    trigger={
      <LabeledInput
        value={values[props.initialValue || 'F']}
        icon='dropdown'
        data-qa='statusSelect'
        readOnly={true}
        label=''
      />
    }
    wrapClassName={cs(css.wrap)}
    closeByClick={true}
    content={
      <MenuList>
        {Object.keys(values).map(k => (<Item
          className={cs('qa-item', `qa-item-${k}`)}
          key={k}
          fn={handle(props, k)}
          title={values[k]}
        />))}
      </MenuList>
    }
  />
);

export default statusSelect;



// WEBPACK FOOTER //
// ./src/components/Alert/AlertList/List/StatusSelect/index.js